import { render, staticRenderFns } from "./LeavePageApplicationPending.vue?vue&type=template&id=33ae6e91&scoped=true&"
import script from "./LeavePageApplicationPending.vue?vue&type=script&lang=js&"
export * from "./LeavePageApplicationPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae6e91",
  null
  
)

export default component.exports